// Sums of doubles cancel to residue (e.g. 3.5e-15) instead of 0, and a baseline
// below one cent is no meaningful divisor anyway: both count as "no baseline".
export const minMeaningfulDeltaBaseline = 0.01;

// Mirrors safeDeltaPercentSql in src/server/utils/safe-delta-percent-sql.ts.
// Returns the ratio (0.15 = +15%), or undefined when no meaningful % exists:
// 0 -> 0, a sub-cent baseline, or a loss turning into a profit.
// Two negative periods compare against |last| (-100 -> -50 is +50%).
// An exactly-zero baseline is capped at +/-100%, so new revenue reads as +100%.
// Arrow direction should be derived from the delta amount, not from this value.
export function safeDeltaPercentage(current: number, last: number): number | undefined {
    if (last >= minMeaningfulDeltaBaseline) {
        return (current - last) / last;
    }
    if (last <= -minMeaningfulDeltaBaseline && current < 0) {
        return (current - last) / Math.abs(last);
    }
    if (last === 0 && current !== 0) {
        return Math.sign(current);
    }
}
